import { render, staticRenderFns } from "./customsClearanceIssued.vue?vue&type=template&id=12ae9606&scoped=true&"
import script from "./customsClearanceIssued.vue?vue&type=script&lang=js&"
export * from "./customsClearanceIssued.vue?vue&type=script&lang=js&"
import style0 from "./customsClearanceIssued.vue?vue&type=style&index=0&id=12ae9606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ae9606",
  null
  
)

export default component.exports